'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      tableData: []
    };
  },

  props: ['getUrl', 'historyTitle', 'dateLabel', 'commentLabel', 'categoryLabel', 'riskLevelLabel'],
  mounted: function mounted() {
    var self = this;
    var uri = this.getUrl;
    this.axios.get(uri).then(function (response) {
      self.tableData = response.data;
    }).catch(function (error) {
      if (error.response != 'undefined' && error.response.status >= 500 || error.message === "Network Error") {
        self.$notify({
          title: 'Update failed',
          message: 'Due to network or server problems, history can not be loaded. Please try again later.',
          type: 'error',
          offset: 150
        });
      } else {
        console.error(error);
      }
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/history.vue
// module id = ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/history.vue
// module chunks = 0